/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MoveCompaniesRequest
 */
export interface MoveCompaniesRequest {
  /**
   *
   * @type {string}
   * @memberof MoveCompaniesRequest
   */
  fromListId: string;
  /**
   *
   * @type {string}
   * @memberof MoveCompaniesRequest
   */
  toListId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof MoveCompaniesRequest
   */
  companyIds: Array<string>;
}

/**
 * Check if a given object implements the MoveCompaniesRequest interface.
 */
export function instanceOfMoveCompaniesRequest(
  value: object,
): value is MoveCompaniesRequest {
  if (!("fromListId" in value) || value["fromListId"] === undefined)
    return false;
  if (!("toListId" in value) || value["toListId"] === undefined) return false;
  if (!("companyIds" in value) || value["companyIds"] === undefined)
    return false;
  return true;
}

export function MoveCompaniesRequestFromJSON(json: any): MoveCompaniesRequest {
  return MoveCompaniesRequestFromJSONTyped(json, false);
}

export function MoveCompaniesRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MoveCompaniesRequest {
  if (json == null) {
    return json;
  }
  return {
    fromListId: json["fromListId"],
    toListId: json["toListId"],
    companyIds: json["companyIds"],
  };
}

export function MoveCompaniesRequestToJSON(json: any): MoveCompaniesRequest {
  return MoveCompaniesRequestToJSONTyped(json, false);
}

export function MoveCompaniesRequestToJSONTyped(
  value?: MoveCompaniesRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fromListId: value["fromListId"],
    toListId: value["toListId"],
    companyIds: value["companyIds"],
  };
}
